/* unplugin-vue-components disabled */import script from "./PlayerContractNegotiationStarter.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlayerContractNegotiationStarter.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__